<template>
  <div>
    <v-dialog v-model="value" scrollable max-width="655px">
      <v-card class="pa-0">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer></v-spacer>
          <span class="mdlHeadForms">{{ sTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn  color="btncolor-dark" @click="CloseDialog()" icon small dark outlined>
            <v-icon size="15px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-2" style="max-height: 80vh;min-height: 80px;">
          <div class="mx-auto text-center pa-2">
            <fulfilling-bouncing-circle-spinner
              v-if="bCargandoInformacion"
              :animation-duration="4000"
              :size="40"
              color='#0E69B0'
              class="mx-auto"
            />
          </div>
          <v-container fluid v-if="!bCargandoInformacion">
            <v-row class="no-gutters" v-if="oDataAnexos.archivos.length >= 1 || oDataAnexos.imagenes.length >= 1" >
              <v-col cols="12" class="text-right">
                <v-btn small color="primary" @click="onDescargarTodo" :loading="bDescargarTodo">{{$store.state.jsIdioma.oEquivalencias.btnDescargarTodo}}<v-icon right>mdi-download</v-icon></v-btn>
              </v-col>
              <v-col cols="12" class="text-center mt-2 animated fadeIn" v-if="bAlertDescargo">
                <v-alert dense text type="success" dismissible v-model="bAlertDescargo">
                    <strong>{{$store.state.jsIdioma.oEquivalencias.msgDescargaCorrecta}}</strong>
                    <span v-if="this.nErrores >= 1" >, con {{this.nErrores}} errores</span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row class="no-gutters" >
              <div class="my-2">
                <span class="text-medium text-primary font-size-1">{{$store.state.jsIdioma.oEquivalencias.lblArchivos}}</span>
              </div>
              <v-col cols="12" v-if="oDataAnexos.archivos.length == 0"  class="text-center pa-1 under-sec-flat-gray">
                <v-icon color="primary" class="animated bounceIn dura-1" size="60px">mdi-information</v-icon>
                <h2 class="text-medium text-primary font-size-1">
                  {{$store.state.jsIdioma.oEquivalencias.msgSinInformacion}}
                </h2>
              </v-col>
              <v-col cols="12" class="no-gutters" v-for="(archivo, i) in oDataAnexos.archivos" :key="'reporte-'+i" >
                <v-card width="100%" class="my-1">
                  <v-list-item class="grow pa-1">
                    <v-card-text class="pa-2">{{ archivo.nombre }}</v-card-text>
                    <div align="center" class="d-flex" >
                      <v-btn color="primary" class="mx-1" dark outlined icon download :href="archivo.urlAnexo" target="_blank"> 
                        <v-icon size="20px">mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="no-gutters">
              <v-col cols="12" class="my-1">
                <span class="text-medium text-primary font-size-1">{{$store.state.jsIdioma.oEquivalencias.lblImagenes}}</span>
              </v-col>
              <v-col cols="12" v-if="oDataAnexos.imagenes.length == 0"  class="text-center pa-1 under-sec-flat-gray">
                <v-icon color="primary" class="animated bounceIn dura-1" size="60px">mdi-information</v-icon>
                <h2 class="text-medium text-primary font-size-1">
                  {{$store.state.jsIdioma.oEquivalencias.msgSinInformacion}}
                </h2>
              </v-col>
              <v-col
                  v-for="(iImagen , n) in oDataAnexos.imagenes"
                  :key="'iImagen'+n"
                  class="d-flex child-flex"
                  :cols="oDataAnexos.imagenes.length <= 2 ? '6' : '4'"
                >
                  <v-img
                    :src="iImagen.urlAnexo"
                    :lazy-src="iImagen.urlAnexo"
                    aspect-ratio="1"
                    class="grey lighten-2 mx-auto"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
              </v-col>
              <!-- DIV PARA DESCARGAR IMAGENES -->
              <div id="htmlImagen"></div>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
export default {
  name:'AnexosRecomendacion',
  components: {
    FulfillingBouncingCircleSpinner,
  },
  props:{
    value:{
      type: Boolean,
      default: false
    },
    sTitle: {
      type: String,
      default: 'Anexos'
    },
    oDataAnexos:{
      type: Object
    },
    bCargandoInformacion:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      bDescargarTodo : false,
      bAlertDescargo : false,
      nErrores : 0
    }
  },
  methods: {
    CloseDialog(){
     this.$emit('input', false)
    },
    anexosAction(){
      this.verAnexos = true
    },
    async onDescargarTodo() {
      this.nErrores = 0
      this.bDescargarTodo = true
      let oDivImagen = document.getElementById('htmlImagen');
      this.oDataAnexos.imagenes.forEach((oElemento, nIdx) => {
        try{
          if(oElemento.urlAnexo === 'data:image/'){
            this.nErrores++
          }else{
            let newA = document.createElement('a')
            oDivImagen.appendChild(newA)
            newA.href = oElemento.urlAnexo
            newA.download = `imagen-${nIdx+1}.${this.onObtenerExtension(oElemento.urlAnexo)}`
            newA.click()
            oDivImagen.removeChild(oDivImagen.firstChild)
          }
        }catch(error){
          //console.log(error)
          this.nErrores++
        }
      });
      this.oDataAnexos.archivos.forEach(async (oElemento) => {
        try{
          const responseVal = await fetch(oElemento.urlAnexo, { method: 'HEAD' });
          if (responseVal.ok) {
            const response = await fetch(oElemento.urlAnexo)
            const blob = await response.blob()
            let newA = document.createElement('a')
            oDivImagen.appendChild(newA)
            newA.href = URL.createObjectURL(blob)
            newA.download = `${oElemento.nombre}`
            newA.click()
            oDivImagen.removeChild(oDivImagen.firstChild)
          } else {
            this.nErrores++
          }
        }catch(error){
          //console.log(error)
          this.nErrores++
        }
      });
      this.bDescargarTodo = false
      this.bAlertDescargo = true
    },
    onObtenerExtension(sBase64) {
      try{
        let aExtension = sBase64.split(';')[0]
        return aExtension.split('/')[1]
      }catch(error){
        //console.log(error)
        return 'png'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mdlHeadForms{
  font-size: 0.9em;
}
</style>